import React from 'react'
import PropTypes from 'prop-types'
import { useTranslation } from "react-i18next"

const MEDIA_SPINNER_SIZE = '3rem'

export const LoadingOverlay = ({ 
  isLoading, 
  children,
  uploadProgress = 0
}) => {
  const { t } = useTranslation()
  
  if (!isLoading) return children

  const uploadPercentage = Math.round(uploadProgress)

  return (
    <div className="position-relative h-100 w-100" aria-busy={isLoading}>
      {/* Absolute overlay that covers only the container */}
      <div 
        className="position-absolute top-0 start-0 w-100 h-100 d-flex flex-column align-items-center justify-content-center"
        style={{
          backgroundColor: 'rgba(255, 255, 255, 0.8)',
          backdropFilter: 'blur(3px)',
          zIndex: 9999
        }}
        aria-live="polite"
        aria-label={t('uploading')}
      >
        <div 
          className="spinner-border" 
          style={{ 
            color: "var(--color-sportsman-brand)",
            width: MEDIA_SPINNER_SIZE,
            height: MEDIA_SPINNER_SIZE
          }} 
        >
          <span className="visually-hidden">
            <output>{t('uploading')}</output>
          </span>
        </div>
        
        <div className="mt-3 text-center text-dark">
          {uploadProgress > 0 ? (
            <>
              <output className="d-block mb-2">
                {t('uploading')}: {uploadPercentage}%
              </output>
              <div style={{ width: '200px' }}>
                <progress 
                  className="w-100"
                  value={uploadProgress}
                  max="100"
                  style={{
                    accentColor: 'var(--color-sportsman-brand)',
                    height: '1rem'
                  }}
                />
              </div>
            </>
          ) : (
            <output>{t('uploading')}...</output>
          )}
        </div>
      </div>

      {/* Content container */}
      <div className="opacity-50">
        {children}
      </div>
    </div>
  )
}

LoadingOverlay.propTypes = {
  /** Whether the overlay is currently showing */
  isLoading: PropTypes.bool.isRequired,
  /** Content to be rendered underneath the overlay */
  children: PropTypes.node.isRequired,
  /** Upload progress percentage (0-100) */
  uploadProgress: PropTypes.number
}

// Add display name for better debugging
LoadingOverlay.displayName = 'LoadingOverlay'